export default "__VITE_ASSET__341c011e__"